/**
 * List of operations that will still refetch when the query's options contain a value of true for the skip boolean.
 * Every other operation will silently no-op when trying to refetch if the last seen options contain a skip of true.
 * NOTE: do not add any new operations to this list. If you absolutely must, contact sail-core first.
 */
const refetchOnSkipOperationAllowlist = [
  'BentoInvoicesTableListQuery',
  'BentoPayoutsTableCountQuery',
  'CaptchaInitializationDataQuery',
  'ConversationQuery',
  'FetchInvoiceTemplatesCountQuery',
  'FetchInvoiceTemplatesQuery',
  'GetAllImportSetsQuery',
  'InviteEmailQuery',
  'InvoiceLineItemsQuery',
  'ListEventDeliveriesForDestinationQuery',
  'ListEventDestinationAttemptsTimestampsQuery',
  'ListFilingEnrollmentApplicationsQuery',
  'ListFilingEnrollmentApplicationsStatusQuery',
  'ListFunctionalityAuditLogsQuery',
  'ListMerchantRulesQuery',
  'ListQueriesQuery',
  'ListQueryFilesQuery',
  'ListV1WebhookConversationsTimestampsQuery',
  'ListV1WebhookEndpointsQuery',
  'MerchantContextQuery',
  'PaymentMethodExperimentQuery',
  'PlansAndFeesGetCurrentPricingsQuery',
  'PriceListQuery',
  'PriceSearchQuery',
  'PricingModuleCountQuery',
  'ProductDetailQuery',
  'ProductsTableCountQuery',
  'RadarAllSignalsForChargeQuery',
  'RequestAuthChallengeQuery',
  'RequestRegisterPasskeyQuery',
  'RequireUserChallengeAnonymousQuery',
  'RequireUserChallengePreDashboardQuery',
  'RequireUserChallengeQuery',
  'RetrieveAccountQuery',
  'RetrieveAccountRiskStatusQuery',
  'RetrieveAllPersonsQuery',
  'RetrievePricingPlanQuery',
  'RetrieveTestingScenarioResultsQuery',
  'RetrieveTestingScenarioTimestampsQuery',
  'SdpSettingsPageQuery',
  'StripeInitiatedPayoutPauseExistsQuery',
  'UnifiedCustomersListViewCountQuery',
  'UnifiedCustomersListViewV2Query',
  'UnifiedLightningCustomersListViewV2Query',
  'V1AccountCapabilitiesQuery',
  'V2GetUserAccessibleSandboxWorkspacesQuery',
  'V2RetrieveFullAccountQuery',
  'DoNotDeleteTestQuery',
];

export default refetchOnSkipOperationAllowlist;
